<div class="flex flex-1 items-center">
  <dx-form
    [formData]="formData"
    [readOnly]="readOnly"
    (onFieldDataChanged)="onFieldDataChanged($event)"
    class="flex-1"
  >
    <dxi-item
      dataField="value"
      editorType="dxCheckBox"
      [label]="{ text: $any(item.config.text) }"
    ></dxi-item>
  </dx-form>
  @if (item.config.quickview) {
    <div class="flex flex-row items-center justify-center">
      <i class="fa-light fa-eye opacity-50"></i>
    </div>
  }
</div>
